import { useCallback, useEffect } from 'react';

import { useApiDelete } from '../../api/Api.hooks';
import { useAppContext } from '../../AppContext';

export default function useDeleteStudyParticipantToFavorite(
  userId: number,
  studyParticipantId: number
) {
  const { data, isLoading, error, del, clearData } = useApiDelete(
    `users/${userId}/favorite/study-participant/${studyParticipantId}`
  );

  const { logError } = useAppContext();
  useEffect(
    () => void (error && logError('Delete to favorite error', error)),
    [error, logError]
  );

  const deleteStudyToFavorite = useCallback(() => del(), [del]);
  return {
    deleteStudyToFavoriteData: data,
    deleteStudyToFavoriteIsLoading: isLoading,
    deleteStudyToFavoriteError: error,
    clearDeleteStudyToFavoriteData: clearData,
    deleteStudyToFavorite
  };
}
